import React from 'react';
import type { UnitSystem } from './units';

interface UnitToggleProps {
  value: UnitSystem;
  onChange: (value: UnitSystem) => void;
}

const SEGMENT_WIDTH = 84;
const PADDING = 2;
const TOGGLE_HEIGHT = 28;

/**
 * 自定义的公制/英制切换控件：一个可以平滑左右滑动的边框"套住"当前选中项，
 * 未选中一侧展示为灰底浅色文字（类似禁用按钮），不用 antd Segmented——
 * 它切换后会从 class 驱动的选中态切到内部 thumb 动画，两套样式很难统一调出干净的滑动效果。
 */
const UnitToggle: React.FC<UnitToggleProps> = ({ value, onChange }) => {
  const options: { value: UnitSystem; label: string }[] = [
    { value: 'metric', label: '公制单位' },
    { value: 'imperial', label: '英制单位' },
  ];
  const activeIndex = value === 'metric' ? 0 : 1;

  return (
    <div
      style={{
        position: 'relative',
        display: 'inline-flex',
        background: '#f5f5f5',
        borderRadius: 6,
        padding: PADDING,
        userSelect: 'none',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: PADDING,
          left: PADDING,
          width: SEGMENT_WIDTH,
          height: `calc(100% - ${PADDING * 2}px)`,
          background: '#fff',
          border: '1px solid #1677ff',
          borderRadius: 4,
          boxSizing: 'border-box',
          transform: `translateX(${activeIndex * SEGMENT_WIDTH}px)`,
          transition: 'transform 0.45s cubic-bezier(0.4, 0, 0.2, 1)',
        }}
      />
      {options.map((option) => {
        const active = option.value === value;
        return (
          <div
            key={option.value}
            onClick={() => onChange(option.value)}
            style={{
              position: 'relative',
              zIndex: 1,
              width: SEGMENT_WIDTH,
              height: TOGGLE_HEIGHT,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxSizing: 'border-box',
              cursor: 'pointer',
              fontSize: 13,
              lineHeight: 1,
              color: active ? '#1677ff' : 'rgba(0, 0, 0, 0.35)',
              fontWeight: active ? 600 : 400,
              transition: 'color 0.45s ease',
            }}
          >
            {option.label}
          </div>
        );
      })}
    </div>
  );
};

export default UnitToggle;
